import PropTypes from "prop-types";
import { Radio } from "top-component-library";
import { THROTTLE_EFFECT_TYPE_OPTIONS } from "../constants";
import { StackedButtonGroup } from "../styles";

const OrderRateLimitTypeStep = ({ effectType, onChange }) => (
  <div>
    <h4>What Type of Checkout Limit Do You Want to Configure?</h4>
    <Radio.Group value={effectType} onChange={(event) => onChange(event.target.value)}>
      <StackedButtonGroup>
        {THROTTLE_EFFECT_TYPE_OPTIONS.map((option) => (
          <Radio key={option.value} value={option.value}>
            {option.label}
          </Radio>
        ))}
      </StackedButtonGroup>
    </Radio.Group>
  </div>
);

OrderRateLimitTypeStep.propTypes = {
  effectType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OrderRateLimitTypeStep;
